module.exports = __webpack_public_path__ + "8529af9a2c8d8b2f1b3c6a559b478a41.svg";